<div class="flex flex-1 flex-col gap-2">
  <dx-form
    [formData]="formData"
    (onFieldDataChanged)="onFieldDataChanged()"
    [colCount]="1"
    [readOnly]="readonly"
  >
    <dxi-item itemType="group" [colCount]="2">
      <dxi-item
        dataField="columns"
        [label]="{ text: 'Colonne' | transloco, location: 'top' }"
        [helpText]="'Inserisci i valori separati da una virgola' | transloco"
      ></dxi-item>

      <dxi-item
        dataField="groups"
        [label]="{ text: 'Gruppi' | transloco, location: 'top' }"
        [helpText]="'Inserisci i valori separati da una virgola' | transloco"
      ></dxi-item>
    </dxi-item>

    <dxi-item itemType="group" [colCount]="3">
      <dxi-item
        dataField="rows"
        [label]="{ text: 'Righe' | transloco, location: 'top' }"
        [colSpan]="3"
        [helpText]="'Inserisci i valori separati da una virgola' | transloco"
      ></dxi-item>
    </dxi-item>
  </dx-form>
</div>
